import { createAction, props } from '@ngrx/store';
import { ProductCardData, TabClickEvent } from '@planone/bau365/util-fair-data';
import { FlatLinkClickEvent } from '@planone/shared/util-interfaces';

export const productsShareButtonClicked = createAction(
  '[Product Page] Social share',
  props<{ network: string; product: ProductCardData; exhibitorName: string; fairId: string; pageContext: string }>()
);

export const productsShareDialogOpened = createAction(
  '[Product Page] Social share dialog ',
  props<{ contentType: string; pageContext: string; context: string; product: ProductCardData }>()
);

export const productsTrackedItemClicked = createAction(
  '[Product Page] Tracked item clicked',
  props<FlatLinkClickEvent>()
);

export const productsTabClicked = createAction('[Product Page] Tab option clicked', props<TabClickEvent>());

export const productsPageView = createAction(
  '[Product Page] Page view',
  props<{ productUuid: string; fairId: string }>()
);
